export default class BrightnessMetric {
  /**
   * @type {string[]}
   */
  ag;

  /**
   * @type {string}
   */
  avg;

  /**
   * @type {number}
   */
  d;

  /**
   * @type {string}
   */
  faceup;

  /**
   * @type {string}
   */
  hr;

  /**
   * @type {number}
   */
  rg;

  /**
   * @type {string}
   */
  val;

  /**
   * @type {string}
   */
  ver;

  /**
   * Contains calculated value for radar,
   * value in range in between 0 and 1
   *
   * @type {number}
   */
  gmc;

  /**
   * @param {string[]} ag
   * @param {number} avg
   * @param {number} d
   * @param {number} faceup
   * @param {string} hr
   * @param {number} rg
   * @param {number} val
   * @param {string} ver
   * @param {number} gmc
   */
  constructor({
    ag, avg, d, faceup, hr, rg, val, ver, gmc,
  }) {
    this.ag = ag;
    this.avg = avg ? avg.toFixed(2) : null;
    this.d = d;
    this.faceup = faceup ? faceup.toFixed(2) : null;
    this.hr = hr;
    this.rg = rg;
    this.val = val ? val.toFixed(2) : null;
    this.ver = ver;
    this.gmc = gmc;
  }
}
